import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';
import { addNotification } from './notifications';
import { saveFile } from '../lib/content-lib';

export const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
export const GET_PROJECTS_ERROR = 'GET_PROJECTS_ERROR';

export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_ERROR = 'GET_PROJECT_ERROR';

export const CREATE_PROJECT_REQUEST = 'CREATE_PROJECT_REQUEST';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_ERROR = 'CREATE_PROJECT_ERROR';

export const UPDATE_PROJECT_REQUEST = 'UPDATE_PROJECT_REQUEST';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_ERROR = 'UPDATE_PROJECT_ERROR';

export const CHANGE_STATUS_PROJECT_REQUEST = 'CHANGE_STATUS_PROJECT_REQUEST';
export const CHANGE_STATUS_PROJECT_SUCCESS = 'CHANGE_STATUS_PROJECT_SUCCESS';
export const CHANGE_STATUS_PROJECT_ERROR = 'CHANGE_STATUS_PROJECT_ERROR';

export const REGISTER_PROBLEM_REQUEST = 'REGISTER_PROBLEM_REQUEST';
export const REGISTER_PROBLEM_SUCCESS = 'REGISTER_PROBLEM_SUCCESS';
export const REGISTER_PROBLEM_ERROR = 'REGISTER_PROBLEM_ERROR';

export const DELETE_PROBLEM_REQUEST = 'DELETE_PROBLEM_REQUEST';
export const DELETE_PROBLEM_SUCCESS = 'DELETE_PROBLEM_SUCCESS';
export const DELETE_PROBLEM_ERROR = 'DELETE_PROBLEM_ERROR';

export const UPLOAD_PROJECT_FILES_REQUEST = 'UPLOAD_PROJECT_FILES_REQUEST';
export const UPLOAD_PROJECT_FILES_PROGRESS = 'UPLOAD_PROJECT_FILES_PROGRESS';
export const UPLOAD_PROJECT_FILES_SUCCESS = 'UPLOAD_PROJECT_FILES_SUCCESS';
export const UPLOAD_PROJECT_FILES_ERROR = 'UPLOAD_PROJECT_FILES_ERROR';

export const DELETE_PROJECT_FILE_REQUEST = 'DELETE_PROJECT_FILE_REQUEST';
export const DELETE_PROJECT_FILE_SUCCESS = 'DELETE_PROJECT_FILE_SUCCESS';
export const DELETE_PROJECT_FILE_ERROR = 'DELETE_PROJECT_FILE_ERROR';

export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_ERROR = 'DELETE_PROJECT_ERROR';

export const CLEAN_PROJECTS = 'CLEAN_PROJECTS';

// Get projects
export function getProjects(query) {
    return async (dispatch) => {
        try {
            dispatch(getProjectsRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/projects/query', query, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getProjectsSuccess, getProjectsError));
        } catch (err) {
            dispatch(utilsLib.response(err, getProjectsError));
        }
    };
}
function getProjectsRequest() {
    return {
        type: GET_PROJECTS_REQUEST,
        isFetching: true
    };
}
function getProjectsSuccess (payload) {
    return {
        type: GET_PROJECTS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getProjectsError(errorMessage) {
    return {
        type: GET_PROJECTS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get project
export function getProject(projectId) {

    return async (dispatch) => {
        try {
            dispatch(getProjectRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/projects/${projectId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getProjectSuccess, getProjectError));
        } catch (err) {
            dispatch(utilsLib.response(err, getProjectError));
        }
    };
}
function getProjectRequest() {
    return {
        type: GET_PROJECT_REQUEST,
        isFetching: true
    };
}
function getProjectSuccess (payload) {
    return {
        type: GET_PROJECT_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getProjectError(errorMessage) {
    return {
        type: GET_PROJECT_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Create project
export function createProject(project, options) {
    return async (dispatch) => {
        try {
            dispatch(createProjectRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/projects', {project, options}, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, createProjectSuccess, createProjectError));
        } catch (err) {
            dispatch(utilsLib.response(err, createProjectError));
        }
    };
}
function createProjectRequest() {
    return {
        type: CREATE_PROJECT_REQUEST,
        isFetching: true
    };
}
function createProjectSuccess (payload) {
    return dispatch => {
        // Create notification for create project success
        dispatch(addNotification({
            message: 'Proyecto creado correctamente',
            color: 'green',
            icon: 'tick'
        }));

        dispatch({
            type: CREATE_PROJECT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function createProjectError(errorMessage) {
    return dispatch => {
        // Create notification for create project error
        dispatch(addNotification({
            message: 'Error al crear el proyecto',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CREATE_PROJECT_ERROR,
                isFetching: false,
                error: true,
                errorMessage
        });
    }
}

// Update project
export function updateProject(projectId, project = {}) {
    return async (dispatch) => {
        try {
            dispatch(updateProjectRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/projects/${projectId}`, project, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, updateProjectSuccess, updateProjectError));
        } catch (err) {
            dispatch(utilsLib.response(err, updateProjectError));
        }
    };
}
function updateProjectRequest() {
    return {
        type: UPDATE_PROJECT_REQUEST,
        isFetching: true
    };
}
function updateProjectSuccess (payload) {
    return dispatch => {
        // Create notification for update project success
        dispatch(addNotification({
            message: 'Proyecto actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPDATE_PROJECT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function updateProjectError(errorMessage) {
    return dispatch => {
        // Create notification for update project error
        dispatch(addNotification({
            message: 'Error al actualizar el proyecto',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPDATE_PROJECT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Change project status
export function changeProjectStatus(projectId, status, options = { calculateStatistics: true, populateRefs: true, deleteVirtuals: true }) {
    return async (dispatch) => {
        try {
            dispatch(changeProjectStatusRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.put(`/api/projects/${projectId}/status`, { status, options }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, changeProjectStatusSuccess, changeProjectStatusError));
        } catch (err) {
            dispatch(utilsLib.response(err, changeProjectStatusError));
        }
    };
}
function changeProjectStatusRequest() {
    return {
        type: CHANGE_STATUS_PROJECT_REQUEST,
        isFetching: true
    };
}
function changeProjectStatusSuccess (payload) {
    return dispatch => {
        // Create notification for update status success
        dispatch(addNotification({
            message: 'Estado actualizado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: CHANGE_STATUS_PROJECT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function changeProjectStatusError(errorMessage) {
    return dispatch => {
        // Create notification for update status error
        dispatch(addNotification({
            message: 'Error al actualizar el estado',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: CHANGE_STATUS_PROJECT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Register Problem
export function registerProblem(projectId, problem) {
    return async (dispatch) => {
        try {
            dispatch(registerProblemRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/projects/${projectId}/problems`, { problem }, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, registerProblemSuccess, registerProblemError));
        } catch (err) {
            dispatch(utilsLib.response(err, registerProblemError));
        }
    };
}
function registerProblemRequest() {
    return {
        type: REGISTER_PROBLEM_REQUEST,
        isFetching: true
    };
}
function registerProblemSuccess (payload) {
    return dispatch => {
        // Create notification for register problem success
        dispatch(addNotification({
            message: 'Incidencia registrada correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: REGISTER_PROBLEM_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function registerProblemError(errorMessage) {
    return dispatch => {
        // Create notification for register problem error
        dispatch(addNotification({
            message: 'Error al registrar la incidencia',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: REGISTER_PROBLEM_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete Problem
export function deleteProblem(projectId, problemId) {
    return async (dispatch) => {
        try {
            dispatch(deleteProblemRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/projects/${projectId}/problems/${problemId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteProblemSuccess, deleteProblemError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteProblemError));
        }
    };
}
function deleteProblemRequest() {
    return {
        type: DELETE_PROBLEM_REQUEST,
        isFetching: true
    };
}
function deleteProblemSuccess (payload) {
    return dispatch => {
        // Create notification for delete problem success
        dispatch(addNotification({
            message: 'Incidencia borrada correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_PROBLEM_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteProblemError(errorMessage) {
    return dispatch => {
        // Create notification for delete problem error
        dispatch(addNotification({
            message: 'Error al borrar la incidencia',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_PROBLEM_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Upload project files
export function uploadProjectFiles(projectId, files) {
    return async (dispatch) => {
        try {
            dispatch(uploadProjectFilesRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post(`/api/projects/${projectId}/files`, files, {
                headers: { 'Authorization': 'Bearer ' + token },
                onUploadProgress: function (e) {
                    dispatch(uploadProjectFilesProgress(e.loaded / e.total))
                }
            });

            dispatch(utilsLib.response(res, uploadProjectFilesSuccess, uploadProjectFilesError));
        } catch (err) {
            dispatch(utilsLib.response(err, uploadProjectFilesError));
        }
    };
}
function uploadProjectFilesRequest() {
    return {
        type: UPLOAD_PROJECT_FILES_REQUEST,
        isFetching: true
    };
}
function uploadProjectFilesProgress(percent) {
    return {
      type: UPLOAD_PROJECT_FILES_PROGRESS,
      percent
    };
}
function uploadProjectFilesSuccess (payload) {
    return dispatch => {
        // Create notification for upload project file success
        dispatch(addNotification({
            message: 'Ficheros subidos correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: UPLOAD_PROJECT_FILES_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function uploadProjectFilesError(errorMessage) {
    return dispatch => {
        // Create notification for upload project file error
        dispatch(addNotification({
            message: 'Error al subir los ficheros',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: UPLOAD_PROJECT_FILES_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Download project file
export function downloadProjectFile(projectId, fileId) {
    return async (dispatch) => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.get(`/api/projects/${projectId}/files/${fileId}`, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });

            if( res.status === 200 ) {
                saveFile(res);
            }

        } catch (err) {
            dispatch(addNotification({
                message: 'Error al descargar el fichero',
                color: 'red',
                icon: 'warning-sign'
            }));
        }
    };
}

// Delete project file
export function deleteProjectFile(projectId, fileId) {
    return async (dispatch) => {
        try {
            dispatch(deleteProjectFileRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/projects/${projectId}/files/${fileId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteProjectFileSuccess, deleteProjectFileError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteProjectFileError));
        }
    };
}
function deleteProjectFileRequest() {
    return {
        type: DELETE_PROJECT_FILE_REQUEST,
        isFetching: true
    };
}
function deleteProjectFileSuccess (payload) {
    return dispatch => {
        // Create notification for delete file success
        dispatch(addNotification({
            message: 'Fichero eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_PROJECT_FILE_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteProjectFileError(errorMessage) {
    return dispatch => {
        // Create notification for delete file error
        dispatch(addNotification({
            message: 'Error al eliminar el fichero',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_PROJECT_FILE_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Delete project
export function deleteProject(projectId) {

    return async (dispatch) => {
        try {
            dispatch(deleteProjectRequest());
            const token = Auth.getLocalJwt();
            const res = await axios.delete(`/api/projects/${projectId}`, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, deleteProjectSuccess, deleteProjectError));
        } catch (err) {
            dispatch(utilsLib.response(err, deleteProjectError));
        }
    };
}
function deleteProjectRequest() {
    return {
        type: DELETE_PROJECT_REQUEST,
        isFetching: true
    };
}
function deleteProjectSuccess (payload) {
    return dispatch => {
        // Create notification for delete project success
        dispatch(addNotification({
            message: 'Proyecto eliminado correctamente',
            color: 'green',
            icon: 'tick'
        }));
        dispatch({
            type: DELETE_PROJECT_SUCCESS,
            isFetching: false,
            error: false,
            payload
        });
    }
}
function deleteProjectError(errorMessage) {
    return dispatch => {
        // Create notification for delete project error
        dispatch(addNotification({
            message: 'Error al eliminar el proyecto',
            color: 'red',
            icon: 'warning-sign'
        }));
        dispatch({
            type: DELETE_PROJECT_ERROR,
            isFetching: false,
            error: true,
            errorMessage
        });
    }
}

// Clean projects reducer
export function cleanProjects() {
    return {
        type: 'CLEAN_PROJECTS',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/projects.js